import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-report-esign',
    templateUrl: './report-esign.component.html',
    styleUrls: ['./report-esign.component.scss'],
    standalone: false
})
export class ReportEsignComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
